import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard,
  Users,
  Truck,
  Package,
  Tags,
  FileText,
  ShoppingCart,
  ScanLine,
  Wallet,
  BookOpen,
  AlertTriangle,
  ClipboardList,
  BarChart3,
  LogOut,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const nav = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/customers", label: "Customers", icon: Users },
  { to: "/suppliers", label: "Suppliers", icon: Truck },
  { to: "/items", label: "Parts Master", icon: Package },
  { to: "/pricelists", label: "Price Lists", icon: Tags },
  { to: "/invoices", label: "Invoices", icon: FileText },
  { to: "/purchase-orders", label: "Purchase Orders", icon: ShoppingCart },
  { to: "/bills", label: "Supplier Bills", icon: ScanLine },
  { to: "/terms", label: "Terms Library", icon: ClipboardList },
  { to: "/payments", label: "Payments", icon: Wallet },
  { to: "/ledger", label: "Ledger", icon: BookOpen },
  { to: "/overdue", label: "Overdue", icon: AlertTriangle },
  { to: "/financials", label: "Financials", icon: BarChart3 },
];

export default function AppShell() {
  const { logout, company, user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid grid-cols-[260px_1fr]">
      <aside className="border-r border-slate-200 bg-white flex flex-col">
        <div className="px-5 py-4 border-b border-slate-200">
          <img
            src="/logo.jpg"
            alt={company?.name || "The Smith International"}
            className="h-14 w-auto object-contain"
            data-testid="app-logo"
          />
          <div className="text-[10px] tracking-[0.3em] uppercase text-indigo-600 font-semibold mt-2">
            Trading ERP
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-${n.label.toLowerCase().replaceAll(" ", "-")}`}
            >
              <n.icon className="w-4 h-4" />
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-slate-200 px-4 py-3 space-y-1">
          <div className="text-xs text-slate-500">Signed in as</div>
          <div className="text-sm font-medium truncate">{user?.email}</div>
          <Button
            variant="outline"
            size="sm"
            className="w-full mt-2"
            onClick={async () => {
              await logout();
              navigate("/login");
            }}
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" /> Sign out
          </Button>
        </div>
      </aside>

      <main className="min-h-screen bg-slate-50">
        <Outlet />
      </main>
    </div>
  );
}
